export function buildAnnualReportTypesUrl() {
  return '/api/reports/annual-report/types';
}

export function buildAnnualReportPreviewPayload({ startDate, endDate, programType }) {
  return {
    startDate,
    endDate,
    programType
  };
}

export function normalizeAnnualReportTypes(response) {
  const types = Array.isArray(response) ? response : response?.types || [];
  return types
    .filter((type) => type?.id && type?.label)
    .map((type) => ({ id: String(type.id), label: type.label }));
}